import { Slide } from '@/components/core/Slide';
import audioFile from './05-terminal-wakeup.mp3';

export const slide = () => {
  return (
    <Slide
      notes="EVA connecting to environmental systems and microphone"
      audio={audioFile}
      autoNext={10000}
      visualizer="bottom-right"
      terminal={{
        phases: [
          {
            type: 'command',
            content: 'eva_connect --env-systems --audio-input',
          },
          {
            type: 'matrix',
            content: 'ESTABLISHING ENVIRONMENTAL CONNECTIONS...',
          },
          {
            type: 'table',
            content: '',
            header: ['SYSTEM', 'STATUS', 'LATENCY'],
            data: [
              ['Room Sensors', 'CONNECTED', '12ms'],
              ['Climate Control', 'CONNECTED', '8ms'],
              ['Lighting Systems', 'CONNECTED', '5ms'],
              ['Audio Input', 'CONNECTING...', '--'],
            ],
          },
          {
            type: 'matrix',
            content: 'INITIALIZING MICROPHONE INTERFACE...',
          },
          {
            type: 'access',
            content: 'MICROPHONE ACCESS GRANTED',
          },
          {
            type: 'matrix',
            content: 'CALIBRATING AUDIO INPUT SENSITIVITY...',
          },
          {
            type: 'access',
            content: 'VOICE INTERACTION SYSTEMS READY',
          },
        ],
        config: {
          typingSpeed: 20,
          phaseDelay: 300,
        },
      }}
    >
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
